import { Injectable } from '@angular/core';
import { EaDisplay } from '../pr-display';
import { PrNotificationContainerComponent } from './pr-notification-container/pr-notification-container.component';

@Injectable({
  providedIn: 'root',
})
export class PrNotificationService {
  container: PrNotificationContainerComponent;

  constructor() {}

  info(title: string, description: string, timeout?: number) {
    this.container.notify(EaDisplay.neutral, title, description, timeout);
  }

  success(title: string, description: string, timeout?: number) {
    this.container.notify(EaDisplay.success, title, description, timeout);
  }

  warn(title: string, description: string, timeout?: number) {
    this.container.notify(EaDisplay.warning, title, description, timeout);
  }

  error(title: string, description: string, timeout?: number) {
    this.container.notify(EaDisplay.danger, title, description, timeout);
  }
}
